import React, {useEffect, useState} from "react";
import {useDataProvider, useNotify, usePermissions, useQueryWithStore} from "react-admin";
import {Card, Form, Switch, Typography} from "antd";
import {ExtendedDataProvider} from "@src/types";
import { spinnerElement } from "@src/components/Common/utils";

const {Text} = Typography;

const ManagePackProfile = ({record}: { record: Record<string, any> }) => {
    const dataProvider: ExtendedDataProvider = useDataProvider();
    const notify = useNotify();
    const {permissions} = usePermissions();
    const resource = 'serviceowner_pack_profile';

    const [initialLoading, setInitialLoading] = useState(true);
    const [localProfile, setLocalProfile] = useState<any>(null);
    const [saving, setSaving] = useState(false);

    const { data: profile, loading, loaded } = useQueryWithStore({
        type: 'getAction',
        resource: resource,
        payload: { id: undefined, verb: `service/${record.id}/config` }
    });

    useEffect(() => {
        if (loaded || !loading) {
            setInitialLoading(false);
            setLocalProfile(profile);
        }
    }, [profile, loaded, loading]);

    const handleToggle = (field: string, checked: boolean) => {
        const updated = {...localProfile, [field]: checked};
        setLocalProfile(updated);
        setSaving(true);

        const verb_trigger = `service/${record.id}/`;
        dataProvider.createAction(resource, { data: updated, verb: verb_trigger })
            .then(() => {
                const label = field === 'pack_enabled' ? 'Pack' : 'Universal Executor';
                notify(`${label} ${checked ? 'enabled' : 'disabled'}`);
            })
            .catch((error: any) => {
                setLocalProfile((prev: any) => ({...prev, [field]: !checked}));
                notify(JSON.stringify(error.body), 'error');
            })
            .finally(() => setSaving(false));
    };

    if (initialLoading)
        return spinnerElement;

    return (
        <Card style={{padding: '20px'}}>
            <Text type="secondary" style={{display: 'block', marginBottom: '20px'}}>
                Configure Pack and Universal Executor settings for this service.
            </Text>
            <Form
                labelCol={{span: 5}}
                labelAlign={'left'}
            >
                <Form.Item label="Enable Pack" valuePropName="checked">
                    <Switch
                        checked={localProfile?.pack_enabled || false}
                        onChange={(checked) => handleToggle('pack_enabled', checked)}
                        disabled={permissions !== "ADMIN" || saving}
                    />
                </Form.Item>

                <Form.Item label="Enable Universal Executor" valuePropName="checked">
                    <Switch
                        checked={localProfile?.universal_executor_enabled || false}
                        onChange={(checked) => handleToggle('universal_executor_enabled', checked)}
                        disabled={permissions !== "ADMIN" || saving}
                    />
                </Form.Item>
            </Form>
        </Card>
    );
};

export default ManagePackProfile;